(function ($) {
    $.widget('femcare.counter', {
        options: {
            count: 1,
            min: 1,
            max: 50
        },

        _create: function () {
            this.$increment = $('<div class="counter__increment"><i class="icon-plus"></i></div>');
            this.$input = $('<input id="' + this.element.attr('data-inputid') + '" class="counter__input" type="number"/>');
            this.$input.attr('value', this.options.count);
            this.$input.attr('min', this.options.min);
            this.$input.attr('max', this.options.max);
            this.$decrement = $('<div class="counter__decrement"><i class="icon-minus"></i></div>');

            this.element.append(this.$decrement);
            this.element.append(this.$input);
            this.element.append(this.$increment);

            this.$increment.on('click', function () {
                if (this.options.count + 1 <= this.options.max) {
                    this.options.count++;
                    this.$input.val(this.options.count);
                    this.element.trigger('countChanged', [this.options.count]);
                }
            }.bind(this));

            this.$decrement.on('click', function () {
                if (this.options.count - 1 >= this.options.min) {
                    this.options.count--;
                    this.$input.val(this.options.count);
                    this.element.trigger('countChanged', [this.options.count]);
                }
            }.bind(this));

            this.$input.on('blur', function () {
                var value = this.$input.val();
                var count = value ? parseInt(value, 10) : this.options.min;
                if (count >= this.options.min && count <= this.options.max) {
                    this.options.count = count;
                    this.element.trigger('countChanged', [this.options.count]);
                }
                this.$input.val(this.options.count);
            }.bind(this));
        },

        getCount: function () {
            return this.options.count;
        },

        setCount: function (count) {
            if (count >= this.options.min && count <= this.options.max) {
                this.options.count = count;
                this.$input.val(count);
            }
        },

        getMax: function () {
            return this.options.max;
        },

        setMax: function (max) {
            this.options.max = max;
            this.$input.attr('max', this.options.max);
        }
    });
})(jQuery);
